<ifc-app-scroll-container>
  <div class="wrapper" *ngIf="page">
    <header class="header">
      <h1 class="header__title mat-headline-5">{{ page.title }}</h1>
      <p class="header__subtitle">{{ page.subtitle }}</p>
    </header>
    <ifbp-dashboard-filter-bar
      class="filter-bar"
      [asOfUtc]="asOfUtc"
      [showPeriod]="page.showPeriod"
    ></ifbp-dashboard-filter-bar>
    <ng-content></ng-content>
  </div>
</ifc-app-scroll-container>
